import { useMemo } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { loadOrders } from "../../data/adminData";
import { fmt, bezPvn } from "../../data/store";
import { PageTitle, Table, Badge, Btn, dt } from "./ui";

export default function Invoices() {
  const invoices = useMemo(() => loadOrders().filter((o) => o.status !== "Atcelts").map((o, i) => ({
    nr: `INV-2026-${String(1001 + i)}`, order: o.nr, customer: o.company || o.customer || "—",
    date: o.date, total: o.total, paid: ["Apmaksāts", "Nosūtīts", "Izpildīts"].includes(o.status),
  })), []);
  return (
    <div data-testid="admin-invoices">
      <PageTitle right={<Btn onClick={() => toast.success("Eksports sagatavots (DEMO)", { description: "CSV fails ar visiem rēķiniem grāmatvedībai." })} data-testid="invoices-export">Eksportēt CSV</Btn>}>
        Rēķini ({invoices.length})
      </PageTitle>
      <Table head={["Rēķina nr.", "Pasūtījums", "Klients", "Datums", "Bez PVN", "PVN 21%", "Kopā", "Statuss", ""]}>
        {invoices.map((inv) => (
          <tr key={inv.nr} className="border-b border-[#F5F5F5] hover:bg-[#F5F5F5]" data-testid={`invoice-row-${inv.nr}`}>
            <td className="p-3 font-bold">{inv.nr}</td>
            <td className="text-[#6B6B6B]">{inv.order}</td>
            <td>{inv.customer}</td>
            <td className="text-[#6B6B6B]">{dt(inv.date)}</td>
            <td>{fmt(bezPvn(inv.total))}</td>
            <td>{fmt(inv.total - bezPvn(inv.total))}</td>
            <td className="font-bold">{fmt(inv.total)}</td>
            <td><Badge color={inv.paid ? "green" : "amber"}>{inv.paid ? "Apmaksāts" : "Gaida apmaksu"}</Badge></td>
            <td className="p-3">
              <button onClick={() => toast.success(`${inv.nr} PDF lejupielādēts (DEMO)`)} data-testid={`invoice-pdf-${inv.nr}`}
                className="flex items-center gap-1 text-xs font-bold hover:text-[#D0121A]"><Download size={13} /> PDF</button>
            </td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
